export const countries = [
  { country: "Afganistán", code: "+93", flag: "🇦🇫" },
  { country: "Albania", code: "+355", flag: "🇦🇱" },
  { country: "Alemania", code: "+49", flag: "🇩🇪" },
  { country: "Argelia", code: "+213", flag: "🇩🇿" },
  { country: "Andorra", code: "+376", flag: "🇦🇩" },
  { country: "Angola", code: "+244", flag: "🇦🇴" },
  { country: "Argentina", code: "+54", flag: "🇦🇷" },
  { country: "Armenia", code: "+374", flag: "🇦🇲" },
  { country: "Australia", code: "+61", flag: "🇦🇺" },
  { country: "Austria", code: "+43", flag: "🇦🇹" },
  { country: "Azerbaiyán", code: "+994", flag: "🇦🇿" },
  { country: "Bahamas", code: "+1‑242", flag: "🇧🇸" },
  { country: "Bahréin", code: "+973", flag: "🇧🇭" },
  { country: "Bangladesh", code: "+880", flag: "🇧🇩" },
  { country: "Barbados", code: "+1‑246", flag: "🇧🇧" },
  { country: "Bélgica", code: "+32", flag: "🇧🇪" },
  { country: "Belice", code: "+501", flag: "🇧🇿" },
  { country: "Benín", code: "+229", flag: "🇧🇯" },
  { country: "Bhután", code: "+975", flag: "🇧🇹" },
  { country: "Bolivia", code: "+591", flag: "🇧🇴" },
  { country: "Bosnia y Herzegovina", code: "+387", flag: "🇧🇦" },
  { country: "Botsuana", code: "+267", flag: "🇧🇼" },
  { country: "Brasil", code: "+55", flag: "🇧🇷" },
  { country: "Brunei", code: "+673", flag: "🇧🇳" },
  { country: "Bulgaria", code: "+359", flag: "🇧🇬" },
  { country: "Canadá", code: "+1", flag: "🇨🇦" },
  { country: "Cabo Verde", code: "+238", flag: "🇨🇻" },
  { country: "Camboya", code: "+855", flag: "🇰🇭" },
  { country: "Camerún", code: "+237", flag: "🇨🇲" },
  { country: "Chile", code: "+56", flag: "🇨🇱" },
  { country: "China", code: "+86", flag: "🇨🇳" },
  { country: "Colombia", code: "+57", flag: "🇨🇴" },
  { country: "Costa Rica", code: "+506", flag: "🇨🇷" },
  { country: "Croacia", code: "+385", flag: "🇭🇷" },
  { country: "Cuba", code: "+53", flag: "🇨🇺" },
  { country: "Chipre", code: "+357", flag: "🇨🇾" },
  { country: "Dinamarca", code: "+45", flag: "🇩🇰" },
  { country: "Ecuador", code: "+593", flag: "🇪🇨" },
  { country: "Egipto", code: "+20", flag: "🇪🇬" },
  { country: "El Salvador", code: "+503", flag: "🇸🇻" },
  { country: "Emiratos Árabes Unidos", code: "+971", flag: "🇦🇪" },
  { country: "Eritrea", code: "+291", flag: "🇪🇷" },
  { country: "Eslovenia", code: "+386", flag: "🇸🇮" },
  { country: "España", code: "+34", flag: "🇪🇸" },
  { country: "Estados Unidos", code: "+1", flag: "🇺🇸" },
  { country: "Estonia", code: "+372", flag: "🇪🇪" },
  { country: "Etiopía", code: "+251", flag: "🇪🇹" },
  { country: "Filipinas", code: "+63", flag: "🇵🇭" },
  { country: "Finlandia", code: "+358", flag: "🇫🇮" },
  { country: "Francia", code: "+33", flag: "🇫🇷" },
  { country: "Grecia", code: "+30", flag: "🇬🇷" },
  { country: "Guatemala", code: "+502", flag: "🇬🇹" },
  { country: "Guyana", code: "+592", flag: "🇬🇾" },
  { country: "Haití", code: "+509", flag: "🇭🇹" },
  { country: "Honduras", code: "+504", flag: "🇭🇳" },
  { country: "Hungría", code: "+36", flag: "🇭🇺" },
  { country: "India", code: "+91", flag: "🇮🇳" },
  { country: "Indonesia", code: "+62", flag: "🇮🇩" },
  { country: "Irlanda", code: "+353", flag: "🇮🇪" },
  { country: "Islandia", code: "+354", flag: "🇮🇸" },
  { country: "Italia", code: "+39", flag: "🇮🇹" },
  { country: "Japón", code: "+81", flag: "🇯🇵" },
  { country: "Jordania", code: "+962", flag: "🇯🇴" },
  { country: "Kenia", code: "+254", flag: "🇰🇪" },
  { country: "Kuwait", code: "+965", flag: "🇰🇼" },
  { country: "Líbano", code: "+961", flag: "🇱🇧" },
  { country: "Luxemburgo", code: "+352", flag: "🇱🇺" },
  { country: "Malasia", code: "+60", flag: "🇲🇾" },
  { country: "Marruecos", code: "+212", flag: "🇲🇦" },
  { country: "México", code: "+52", flag: "🇲🇽" },
  { country: "Nicaragua", code: "+505", flag: "🇳🇮" },
  { country: "Noruega", code: "+47", flag: "🇳🇴" },
  { country: "Nueva Zelanda", code: "+64", flag: "🇳🇿" },
  { country: "Países Bajos", code: "+31", flag: "🇳🇱" },
  { country: "Panamá", code: "+507", flag: "🇵🇦" },
  { country: "Paraguay", code: "+595", flag: "🇵🇾" },
  { country: "Perú", code: "+51", flag: "🇵🇪" },
  { country: "Polonia", code: "+48", flag: "🇵🇱" },
  { country: "Portugal", code: "+351", flag: "🇵🇹" },
  { country: "Puerto Rico", code: "+1‑939", flag: "🇵🇷" },
  { country: "Reino Unido", code: "+44", flag: "🇬🇧" },
  { country: "República Checa", code: "+420", flag: "🇨🇿" },
  { country: "Rumanía", code: "+40", flag: "🇷🇴" },
  { country: "Rusia", code: "+7", flag: "🇷🇺" },
  { country: "Senegal", code: "+221", flag: "🇸🇳" },
  { country: "Serbia", code: "+381", flag: "🇷🇸" },
  { country: "Singapur", code: "+65", flag: "🇸🇬" },
  { country: "Sudáfrica", code: "+27", flag: "🇿🇦" },
  { country: "Suecia", code: "+46", flag: "🇸🇪" },
  { country: "Suiza", code: "+41", flag: "🇨🇭" },
  { country: "Tailandia", code: "+66", flag: "🇹🇭" },
  { country: "Túnez", code: "+216", flag: "🇹🇳" },
  { country: "Turquía", code: "+90", flag: "🇹🇷" },
  { country: "Ucrania", code: "+380", flag: "🇺🇦" },
  { country: "Uruguay", code: "+598", flag: "🇺🇾" },
  { country: "Venezuela", code: "+58", flag: "🇻🇪" },
  { country: "Vietnam", code: "+84", flag: "🇻🇳" },
];
